import { Filter } from '~commonInfra/utils/Filter';

import { IListFetcher } from '../../httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IDetailResource, IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { ILeafFilterClause } from '../../spacesPlatform/models/IFilterClause';
import { NamedItemKeys } from '../../spacesPlatform/models/resourceParts';
import { GetProjectNamesRequest, IGetProjectNamesResult } from '../ServerApi/requests/GetProjectNamesRequest';
import { IProjectName } from '../ServerApi/types/IProject';

class ProjectNamesResource implements IListResource<IProjectName>, IDetailResource<IProjectName> {

  private listFetcher: IListFetcher<IProjectName> = new WebClientListResourceFetcher(
    GetProjectNamesRequest,
    (result: IGetProjectNamesResult) => result.projects);

  public all(): ResourceQuery<IProjectName> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<IProjectName> {
    return this.all()
        .withFilters(additionalFilterClauses ?? [])
        .addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
        .getFirst();
  }
}

export const ProjectNames = new ProjectNamesResource;
